import { SET_MODE, CHECK_MODE } from '../mutation-types';

export default {
  namespaced: true,
  state: {
    darkMode: false,
  },
  mutations: {
    [SET_MODE](state) {
      state.darkMode = !state.darkMode;
      const objectToSave = { darkMode: state.darkMode };
      localStorage.setItem('layout', JSON.stringify(objectToSave));
    },
    [CHECK_MODE](state) {
      let data = localStorage.getItem('layout');
      const hasMode = !!data;
      if (hasMode) {
        data = JSON.parse(data);
        const { darkMode } = data;
        state.darkMode = darkMode;
      }
    },
  },
  actions: {
    setMode({ commit }) {
      commit(SET_MODE);
    },
    check({ commit }) {
      commit(CHECK_MODE);
    },
  },
  getters: {
    currentMode(state) {
      return state.darkMode;
    },
  },
};
